export const colors = {
  primary: "#0EA5E9",
  primaryLight: "#EAECFF",
  primaryDark: "#3730A3",
  secondary: "#10B981",
  secondaryLight: "#D1FAE5",
  background: "#F9FAFB",
  backgroundAlt: "#F3F4F6",
  surface: "#FFFFFF",
  error: "#EF4444",
  warning: "#F59E0B",
  info: "#3B82F6",
  text: "#1F2937",
  textSecondary: "#6B7280",
  border: "#E5E7EB",
  borderDark: "#D1D5DB",
  disabled: "#9CA3AF"
};

export const DocumentColorEnum = {
  purple: "llama-purple",
  magenta: "llama-magenta",
  red: "llama-red",
  orange: "llama-orange",
  yellow: "llama-yellow",
  lime: "llama-lime",
  teal: "llama-teal",
  cyan: "llama-cyan",
  blue: "llama-blue",
  indigo: "llama-indigo",
};

// order matters! must be high contrast
export const documentColors = [
  DocumentColorEnum.lime,
  DocumentColorEnum.orange,
  DocumentColorEnum.cyan,
  DocumentColorEnum.yellow,
  DocumentColorEnum.magenta,
  DocumentColorEnum.red,
  DocumentColorEnum.purple,
  DocumentColorEnum.teal,
  DocumentColorEnum.indigo,
  DocumentColorEnum.blue,
];
